import {
    createCompanyLinkRequest,
    getMyCompanyLinkRequests,
    cancelCompanyLinkRequest,
    dismissCompanyLinkRequest,
} from "@/api/companyLinkRequests";
import { consoleHandlerError } from "@/utils/message";

const state = () => ({
    myRequests: [],
    isLoading: false,
});

const mutations = {
    SET_MY_REQUESTS: (state, payload) => {
        state.myRequests = payload;
    },
    SET_LOADING: (state, payload) => {
        state.isLoading = payload;
    },
};

const actions = {
    async fetchMyRequests({ commit }) {
        commit("SET_LOADING", true);
        try {
            const { data } = await getMyCompanyLinkRequests();
            commit("SET_MY_REQUESTS", data.requests);
        } catch (error) {
            consoleHandlerError({ error });
        } finally {
            commit("SET_LOADING", false);
        }
    },
    // Crea la solicitud y refresca la lista. NO captura el error: el modal lo
    // maneja localmente para mostrar el mensaje del backend (ya perteneces /
    // solicitud pendiente / RUT inválido).
    async createRequest({ dispatch }, payload) {
        await createCompanyLinkRequest(payload);
        await dispatch("fetchMyRequests");
    },
    async cancelRequest({ dispatch }, id) {
        await cancelCompanyLinkRequest(id);
        await dispatch("fetchMyRequests");
    },
    async dismissRequest({ dispatch }, id) {
        await dismissCompanyLinkRequest(id);
        await dispatch("fetchMyRequests");
    },
};

const getters = {
    // Notificaciones "resueltas" (aprobada/rechazada) que el usuario todavía ve
    // — alimenta el badge. Las pendientes se muestran en gris pero no cuentan.
    notificationsCount: (state) =>
        state.myRequests.filter(
            (request) =>
                request.status === "approved" || request.status === "rejected"
        ).length,
};

export default { namespaced: true, state, mutations, actions, getters };
